/* eslint-disable no-bitwise, no-loop-func */
import { Atom } from './Atom';
import { handleRawCo64, handleRawStco } from './BitShifters';

export function parseNextAtom(arr, offset = 0) {
  if (offset + 8 > arr.length) {
    return undefined;
  }
  const atomLengthByteZero = arr[offset] << (8 * 3);
  const atomLengthByteOne = arr[offset + 1] << (8 * 2);
  const atomLengthByteTwo = arr[offset + 2] << 8;
  const atomLengthByteFour = arr[offset + 3];
  let atomLength = atomLengthByteZero + atomLengthByteOne + atomLengthByteTwo + atomLengthByteFour;

  // Check for extended (64 bit) size.
  if (atomLength === 1) {
    // This will support up to 281TB (2^48) while staying within the 53 bit JS limit.
    const sixtyFourBitAtomLengthByteTen = arr[offset + 10] << (8 * 5);
    const sixtyFourBitAtomLengthByteEleven = arr[offset + 11] << (8 * 4);
    const sixtyFourBitAtomLengthByteTwelve = arr[offset + 12] << (8 * 3);
    const sixtyFourBitAtomLengthByteThirteen = arr[offset + 13] << (8 * 2);
    const sixtyFourBitAtomLengthByteFourteen = arr[offset + 14] << 8;
    const sixtyFourBitAtomLengthByteFifteen = arr[offset + 15];

    atomLength =
      sixtyFourBitAtomLengthByteTen +
      sixtyFourBitAtomLengthByteEleven +
      sixtyFourBitAtomLengthByteTwelve +
      sixtyFourBitAtomLengthByteThirteen +
      sixtyFourBitAtomLengthByteFourteen +
      sixtyFourBitAtomLengthByteFifteen;
  }

  const atomTypeCharacterOne = String.fromCharCode(arr[offset + 4]);
  const atomTypeCharacterTwo = String.fromCharCode(arr[offset + 5]);
  const atomTypeCharacterThree = String.fromCharCode(arr[offset + 6]);
  const atomTypeCharacterFour = String.fromCharCode(arr[offset + 7]);
  const atomType =
    atomTypeCharacterOne + atomTypeCharacterTwo + atomTypeCharacterThree + atomTypeCharacterFour;
  return { type: atomType, length: atomLength };
}

export function isMp4(arr) {
  if (arr.length > 12) {
    const atomType =
      String.fromCharCode(arr[4]) +
      String.fromCharCode(arr[5]) +
      String.fromCharCode(arr[6]) +
      String.fromCharCode(arr[7]);
    console.info('What is the atomType when checking for mp4?', atomType);
    if (atomType === 'ftyp') {
      return true;
    }
  }

  return false;
}

export async function getMoovCorrectedAtom(file, mdatOffset, mdatLength) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const buffer = new Uint8Array(fileReader.result);

      let offset = 0;
      let atom;
      atom = parseNextAtom(buffer, offset);
      while (atom) {
        if (atom.type === 'moof') {
          reject(new Error('Fragmented MP4 Unsupported.'));
          return;
        }
        if (atom.type === 'moov') {
          const moovUint8Array = new Uint8Array(fileReader.result, offset, atom.length);
          const moovAtom = Atom.parse(moovUint8Array);
          for (const trak of moovAtom.traks) {
            if (trak.mdia.minf.stbl.co64) {
              handleRawCo64(trak.mdia.minf.stbl.co64.raw, atom.length);
            } else {
              handleRawStco(trak.mdia.minf.stbl.stco.raw, atom.length);
            }
          }

          resolve(buffer);
          return;
        }
        if (atom.type === 'mdat') {
          reject(new Error('Multiple mdat atoms found.'));
          return;
        }

        offset += atom.length;
        atom = parseNextAtom(buffer, offset);
      }

      reject(new Error('No atoms found in first 10MB #2'));
    };
    fileReader.readAsArrayBuffer(
      file.slice(mdatOffset + mdatLength, mdatOffset + mdatLength + 10000000),
    );
  });
}

export const getUploadOptimizedVideo = async (file) => {
  let mdatOffset = -1;
  const moovOffset = -1;

  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const buffer = new Uint8Array(fileReader.result);
      console.info('What is the buffer from the file reader?', buffer);

      if (!isMp4(buffer)) {
        console.info('IS NOT MP4. RETURNING UNTOUCHED FILE.');
        resolve(file);
        return;
      }

      let offset = 0;
      let atom;
      atom = parseNextAtom(buffer, offset);
      while (atom) {
        if (atom.type === 'moof') {
          resolve(file);
          return;
        }
        if (atom.type === 'moov') {
          if (mdatOffset === -1) {
            resolve(file);
            return;
          }
        } else if (atom.type === 'mdat') {
          if (moovOffset === -1) {
            mdatOffset = offset;
            const mdatLength = atom.length;
            resolve(
              (async () => {
                const moovBytes = await getMoovCorrectedAtom(file, mdatOffset, mdatLength);
                const modifiedFile = new File(
                  [
                    file.slice(0, mdatOffset),
                    moovBytes,
                    file.slice(mdatOffset, mdatOffset + mdatLength),
                  ],
                  'Video Upload',
                  {
                    type: 'video/mp4',
                    lastModified: file.lastModified,
                  },
                );
                return modifiedFile;
              })(),
            );
            return;
          }
        }

        offset += atom.length;
        atom = parseNextAtom(buffer, offset);
      }

      reject(new Error('No atoms found in first 10MB #1'));
    };
    fileReader.readAsArrayBuffer(file.slice(0, 10000000));
  });
};
